import * as React from 'react';
import { useTranslation } from 'react-i18next';

import MoneyView from 'shared/components/MoneyView';
import { isCrypto } from 'utils/product';

import { Investment_IdeaCategory } from '../../../../../__generated__/globalTypes';

interface Props extends React.HTMLAttributes<HTMLSpanElement> {
  ticker?: string | null;
  category?: Investment_IdeaCategory;
  quantity: number;
}

export const QuantityAsset: React.FC<Props> = ({ ticker, category, quantity, ...props }) => {
  const { t } = useTranslation();

  if (!ticker || ticker === 'USD') {
    return <span {...props}>{Math.ceil(quantity)}</span>;
  } else if (!isCrypto(category)) {
    return <span {...props}>{t('{{count}} shares', { count: quantity })}</span>;
  }

  const asset = {
    value: quantity,
    currency: ticker,
  };

  return (
    <MoneyView maximumFractionDigits={6} {...props}>
      {asset}
    </MoneyView>
  );
};
